module.exports = __webpack_public_path__ + "img/produit_7.181d7e01.png";